import React from 'react';
import { useWindowDimensions, Image } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import Truncate from 'react-truncate';
import c from 'classnames';
import { dateFormatter } from '../../../../helpers';
import WysiwygField from '../../../WysiwygField';
import ThemesLabels from '../../../ThemesLabels';

import {
  SCREEN_TABLET,
} from '../../../../config/constants';

const BaseTeaserSmall = (props) => {
  const { t } = useTranslation();
  const { title, image, themes, date, url, summary, type, typeLabel, className, isSearchResult = false } = props;
  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_TABLET;
  const lang = 'nl';
  const noImage = !image;

  const classNames = c('TeaserSmall',
    noImage ? 'TeaserSmall--noImage' : '',
    className);

  return (
    <div className={classNames}>
      {image && (
        <div className="TeaserSmall__image">
          <div className="overlay" />
          <Image
            src={image}
          />
          <div className="triangle triangle--small" />
        </div>
      )}

      {!image && !isSearchResult && (
        <div className="TeaserSmall__image" />
      )}

      <div className="TeaserSmall__info">
        <p className="TeaserSmall__info__type">
          {type ? typeLabel : t('taxonomy_types.themes.type')}
        </p>
        {type && (
          <>
            <span className="dot">&bull;</span>
            <p>{dateFormatter(date, lang, isMobile && true)}</p>
          </>
        )}
      </div>
      <div className="TeaserSmall__content">
        <h4 className="TeaserSmall__heading">
          <CoreLink className="teaser-link" href={url}>
            <Truncate lines={4} ellipsis="...">
              {title}
            </Truncate>
          </CoreLink>
        </h4>
        {summary && (
          <div className="TeaserSmall__summary">
            <Truncate lines={3} ellipsis="...">
              <WysiwygField
                html={summary}
              />
            </Truncate>
          </div>
        )}
        {themes &&
          <ThemesLabels themes={themes} />}
      </div>
    </div>
  );
};

export default BaseTeaserSmall;
